/**
 * AS TRÊS PALAVRAS DO INTERRUPTOR "VER COMO CLIENTE" — de quem as diz.
 *
 * ── POR QUE SAÍRAM DE `features/agents` ───────────────────────────────────
 *
 * Porque o interruptor não é da tela de agentes. Ele governa `useAgentDisplayMode`,
 * que mora em `shared/` e é lido por TODA a superfície que desenha o trabalho de um
 * agente — a conversa do Ben, a coluna dele na inbox, a tela de agentes, e agora a
 * CONVERSA COM O CLIENTE, que é uma feature diferente. Enquanto as frases moravam no
 * dicionário de agentes, o `no-cross-feature` (severidade `error`) impedia a inbox de
 * as importar, e a alternativa era um segundo bloco de três frases em sete idiomas
 * que divergiria do primeiro no primeiro ajuste de texto.
 *
 * O componente que as lê (`PreviewAsClient.vue`) mora ao lado, pelo mesmo motivo e no
 * mesmo movimento. É a mesma mudança que `shared/field-gaps` já fez.
 *
 * ── `preview.` NO PREFIXO ─────────────────────────────────────────────────
 *
 * O componente abre UM escopo local com este dicionário, e um escopo local não vê o
 * global: o prefixo é o que mantém as chaves legíveis à mistura com as do resto.
 */
export const previewMessages = {
	en: {
		preview: {
			previewing: "you are seeing what a client sees",
			asClient: "see as a client",
			asDev: "back to the dev view",
		},
	},
	"pt-BR": {
		preview: {
			previewing: "você está vendo o que um cliente vê",
			asClient: "ver como cliente",
			asDev: "voltar à visão dev",
		},
	},
	el: {
		preview: {
			previewing: "βλέπετε ό,τι βλέπει ένας πελάτης",
			asClient: "προβολή ως πελάτης",
			asDev: "επιστροφή στην προβολή dev",
		},
	},
	es: {
		preview: {
			previewing: "estás viendo lo que ve un cliente",
			asClient: "ver como cliente",
			asDev: "volver a la vista dev",
		},
	},
	fr: {
		preview: {
			previewing: "vous voyez ce qu'un client voit",
			asClient: "voir comme un client",
			asDev: "revenir à la vue dev",
		},
	},
	it: {
		preview: {
			previewing: "stai vedendo ciò che vede un cliente",
			asClient: "vedi come cliente",
			asDev: "torna alla vista dev",
		},
	},
	de: {
		preview: {
			previewing: "Sie sehen, was ein Kunde sieht",
			asClient: "als Kunde ansehen",
			asDev: "zurück zur Dev-Ansicht",
		},
	},
} as const;
